// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pafp-print-img-gallery {
  page-break-after: always;
  break-after: page;
}
.pafp-address {
  font-size: 2em;
}

@media print {
  .PropertyAgentFullPageActual {
    width: 100%;
  }
  .pafp-pd-value {
    padding-left: 1em;
  }
  .pafp-pd-label {
    padding-right: 1em;
    margin-left: 2em;
  }
  .pafp-header-info {
    width: 8.5in;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PropertyAgentFullPageActual.css"],"names":[],"mappings":"AAAA;EACE,wBAAiB;EAAjB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".pafp-print-img-gallery {\n  break-after: page;\n}\n.pafp-address {\n  font-size: 2em;\n}\n\n@media print {\n  .PropertyAgentFullPageActual {\n    width: 100%;\n  }\n  .pafp-pd-value {\n    padding-left: 1em;\n  }\n  .pafp-pd-label {\n    padding-right: 1em;\n    margin-left: 2em;\n  }\n  .pafp-header-info {\n    width: 8.5in;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
